import actions from "./actions";
import reducer from "./reducer";

const charting = {
  actions,
  reducer,
  name: "charting",
};

export default charting;
